export default {
  Dashboard: "لوحة التحكم",
  "All Jobs": "جميع الوظائف",
  Experience: "الخبرة",
  Back: "رجوع",
  "Duties and Responsibilities": "المهام والمسؤوليات",
  "Qualifications / Requirements": "المؤهلات / المتطلبات",
  "Required Documents": "المستندات المطلوبة",
  "Please submit the following documents in a single PDF file":
    "يرجى تقديم المستندات التالية في ملف PDF واحد",
  "Delete This Job": "حذف هذه الوظيفة",
  "Loading Job Details": "جاري تحميل تفاصيل الوظيفة",
  "No data available for this job": "لا توجد بيانات متاحة لهذه الوظيفة",
  "Loading Jobs": "جاري تحميل الوظائف",
  "No Jobs Available": "لا توجد وظائف متاحة",
  Career: "المسار الوظيفي",
  "Post Job": "نشر وظيفة",
  Menu: "القائمة",
  "Add New Job Role": "إضافة دور وظيفي جديد",
  English: "الإنجليزية",
  Arabic: "العربية",
  "Job Title": "المسمى الوظيفي",
  "Job Type": "نوع الوظيفة",
  Experience: "الخبرة",
  Browse: "تصفح",
  "Supported formates: Ico, PNG": "الصيغ المدعومة: Ico, PNG",
  Description: "الوصف",
  "Location/Region": "الموقع/المنطقة",
  Duties: "المهام",
  "Required Documents": "المستندات المطلوبة",
  Qualifications: "المؤهلات",
  Submit: "إرسال",
  "Select Job Type": "اختر نوع الوظيفة",
  "Full Time": "دوام كامل",
  "Part Time": "دوام جزئي",
  Contract: "عقد",
  Internship: "تدريب",
  "First Name": "الاسم الأول",
  "Family Name": "اسم العائلة",
  "Date of Birth": "تاريخ الميلاد",
  Nationality: "الجنسية",
  Residence: "مكان الإقامة",
  Email: "البريد الإلكتروني",
  Phone: "رقم الهاتف",
  Degree: "الدرجة العلمية",
  Major: "التخصص",
  "Notice Period": "فترة الإشعار",
  Resume: "السيرة الذاتية",
  "Export to Excel": "تصدير إلى إكسل",
  Applicants: "المتقدمون",
  "All Applicants": "جميع المتقدمين",
  "Download Resume": "تحميل السيرة الذاتية",
  "View Applicants": "عرض المتقدمين",
  "Job is not available in": "الوظيفة غير متوفرة في",
  "Are you sure you want to delete the job": "هل أنت متأكد أنك تريد حذف المهمة",
  Cancel: "يلغي",
  Confirm: "يتأكد",
  "Sign in to your account": "قم بتسجيل الدخول إلى حسابك",
  "User Name": "اسم المستخدم",
  Password: "كلمة المرور",
  "Sign in": "تسجيل الدخول",
  Actions: "الإجراءات",
  Download: "تحميل",
  Preview: "معاينة",
  Downloading: "جاري التحميل",
  Loading: "جاري التحميل",
  Customer: "العميل",
  "Customer Queries": "استفسارات العملاء",
  "Violation Reports": "تقرير الانتهاكات",
  "No Jobs Available": "لا توجد وظائف متاحة",
  Name: "الاسم",
  Date: "التاريخ",
  "Nature Of Incident": "طبيعة الحادث",
  Message: "الرسالة",
  File: "الملف",
  "Download Report": "تحميل التقرير",
  Subject: "الموضوع",
  "National Id": "الهوية الوطنية",
  "Nature Of Communication": "طبيعة الاتصال",
  Compliance: "الامتثال",
  Action: "الإجراءات",
  "Open Applicants": "المتقدمون المفتوحون",
  Jobs: "الوظائف",
  Edit: "تحرير",
  "Loading...": "جار التحميل...",
  "Job Updated successfully!": "تم تحديث الوظيفة بنجاح!",
  "Error Updating job": "خطأ في تحديث الوظيفة!",
  "Job Applicants": "متقدمي الوظائف",
  "Update Job": "تحديث الوظيفة",

  Reports: "التقارير",
  "Add Financial Statement": "إضافة بيان مالي",
  "Add Board of Director": "إضافة مجلس إدارة",
  "All Reports": "جميع التقارير",
  "File Name": "اسم الملف",
  "File Type": "نوع الملف",
  FinancialStatement: "بيان مالي",
  BoardsOfDirecterReport: "تقرير مجلس الإدارة",
  "Financial Statements": "البيانات المالية",
  "Board of Director Report": "تقرير مجلس الإدارة",
  "Enter English Lable": "أدخل التسمية باللغة الإنجليزية",
  "Selected English Statement": "البيان الإنجليزي المحدد",
  "Browse in English": "تصفح باللغة الإنجليزية",
  "Supported format: PDF only": "الصيغة المدعومة: PDF فقط",
  "Selected Arabic Statement": "البيان العربي المحدد",
  "Browse in Arabic": "تصفح باللغة العربية",
  "Enter Arabic Lable": "أدخل التسمية باللغة العربية",
  "Please upload an image smaller than 2MB.":
    "يرجى تحميل صورة أقل من 2 ميجابايت.",
  "Error fetching Reports:": "خطأ في جلب التقارير:",
  "No Report Available": "لا توجد تقارير متاحة",
  "Successfully Deleted!": "تم الحذف بنجاح!",
  "Error deleting report": "خطأ في حذف التقرير",
  "Statements Added successfully!": "تمت إضافة البيانات بنجاح!",
  "Only PDF files are allowed.": "فقط ملفات PDF مسموح بها.",
  "Please upload a PDF smaller than 5MB.":
    "يرجى تحميل ملف PDF أقل من 5 ميجابايت.",
  "Please upload English Statement!": "يرجى تحميل البيان باللغة الإنجليزية!",
  "Please upload Arabic Statement!": "يرجى تحميل البيان باللغة العربية!",
  "Please upload English Statement Name!":
    "يرجى تحميل اسم البيان باللغة الإنجليزية!",
  "Please upload Arabic Statement Name!":
    "يرجى تحميل اسم البيان باللغة العربية!",
  "Error Adding Statements!": "خطأ في إضافة البيانات!",
};
